import { render, staticRenderFns } from "./CalonNakes.vue?vue&type=template&id=55098802"
import script from "./CalonNakes.vue?vue&type=script&lang=js"
export * from "./CalonNakes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports